'use client';

import React, { JSX, useMemo } from 'react';
import { Button } from '@/components/atoms/Button/Button';
import { Typography } from '@/components/atoms/Typography/Typography';
import { Image } from '@/components/atoms/Image/Image';
import * as Styled from './SelectedFilters.styled';
import { useFiltersStore } from '@/store/useFiltersStore';

/**
 * Displays the selected active filters, shows when we close the filters and there are active filters
 * They can be deselected on click, triggering a reducer update
 */
export const SelectedFilters = ({
  hiddenFiltersIds,
  refSelectedFiltersContainer,
}: {
  hiddenFiltersIds: string[];
  refSelectedFiltersContainer: React.RefObject<HTMLDivElement | null>;
}): JSX.Element => {

  const selectedFilters = useFiltersStore((state) => state.selectedFilters);
  const search = useFiltersStore(
    (state) => state.search
  );
  const areFiltersOpen = useFiltersStore(
    (state) => state.areFiltersOpen
  );
  const toggleFilter = useFiltersStore(
    (state) => state.toggleFilter
  );

  return useMemo(() => {
    return (selectedFilters?.filters?.length ?? 0) > 0 || search?.value ? (
      <Styled.SelectedFiltersRow
        ref={refSelectedFiltersContainer}
        data-is-displayed={
          (selectedFilters?.filters?.length ?? 0) > 0 &&
          !areFiltersOpen
        }
        className="hidden-mobile"
      >
        {selectedFilters?.filters?.map(
          (filter, i) =>
            !hiddenFiltersIds.includes(filter.id) && (
              <Button
                key={`selected-filter-${i}`}
                callbackOnClick={() => toggleFilter(filter)}
                className='btn-selected-filter'
              >
                <Typography text={filter.text} color="secondary" as={'p'} />
                <Image
                  src="/img/icons/cross.svg"
                  alt="close"
                  height={20}
                  width={20}
                  fill={false}
                  styles={{opacity: 0.5}}
                />
              </Button>
            )
        )}
      </Styled.SelectedFiltersRow>
    ) : (
      <></>
    );
  }, [
    selectedFilters,
    search,
    areFiltersOpen,
    toggleFilter,
    refSelectedFiltersContainer,
    hiddenFiltersIds,
  ]);
};
